import 'nprogress/nprogress.css';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import './index.css';
import "@fontsource/lato";
import './content/shared/material-main-datetime.css';

import * as serviceWorker from '../src/serviceWorker';

import App from '../src/App';
import { HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import ScrollTop from '../src/hooks/useScrollTop';
import store from '../src/store';

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
        <HashRouter>
          <ScrollTop />
            <App />
        </HashRouter>
    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
